/* 夏侯淵（字妙才） */
import { L } from '../../core/kit.ts';
import { defineHero, hook, D } from '../define.ts';

export default defineHero({
  id: 'xiahouyuan', name: '夏侯淵', sub: '字妙才', faction: 'wei', role: '射手', weapon: 'bow',
  look: { weaponName: '鐵胎弓', beard: 'mustache', fx: '#a9d4ff' },
  skills: [
    ['穿雲箭', 'bolt', '朝游標射出一支穿透箭，路徑上的敵人都受到 {100/160/220/280} 傷害。', { shape: 'arrow', big: true, range: 800, aim: D(800, 24), cd: 8, mp: [75, 85, 95, 105] }],
    ['神行', 'buff', '回復 {120/180/240/300} 生命，並在 5 秒內攻速 +{30/45/60/75}%。', { sig: 'xhyHaste', heal: [120, 180, 240, 300], as: [30, 45, 60, 75], cd: 16, mp: [70, 80, 90, 100] }],
    ['連珠', 'passive', '每射三下，第三下讓目標暈眩 {0.6/0.8/1/1.2} 秒；對武將暈眩時間減半。', { pv: {}, sig: 'thirdStun', stun: [0.6, 0.8, 1, 1.2], stack: 'shotN', max: 2 }],
    ['狙擊', 'buff', '架弓狙擊 {6/7/8} 秒：普攻必定爆擊 {1.6/2/2.4} 倍，但移動速度只剩 20%。', { sig: 'snipe', dur: [6, 7, 8], mult: [1.6, 2, 2.4], cd: [60, 50, 40], mp: [100, 125, 150] }],
  ],
  // 專屬招式（技能資料裡的 sig，取代該原型的一般動作）：(u, a, k, dt, cross)，this 是 World
  sigSkills: {
    // 疾行：回血並加攻速
    xhyHaste(u, a, k, dt, cross) { const sk = a.sk, lvl = a.lvl; if (cross(0.3)) { this.heal(u, L(sk.heal, lvl)); this.addBuff(u, { id: 'xhyHaste', t: 5, as: L(sk.as, lvl) }); this.fx({ k: 'heal', x: u.x, y: u.y, col: u.spec.fx }); } },
    // 狙擊：一段時間普攻必定爆擊（爆擊在 skillx 的 xCrit 依 u.snipeUntil 處理）
    snipe(u, a, k, dt, cross) { const sk = a.sk, lvl = a.lvl; if (cross(0.3)) { const d = L(sk.dur, lvl); u.snipeUntil = this.t + d; u.snipeMult = L(sk.mult, lvl); this.addBuff(u, { id: 'snipe', t: d, ms: -0.8 }); this.tell(u, `狙擊 ${d} 秒：普攻必定爆擊，移速 20%`, 'info'); } },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 連珠：每第三下普攻暈眩，對武將減半（在裝備觸發之前）
    hook('onHit.pre', 10, function (u, t) {
      if (u.kind === 'hero' && t.alive && !t.structure && u.spec.skills) {
        const i = u.spec.skills.findIndex((s) => s.sig === 'thirdStun');
        if (i >= 0 && u.skillLv[i] && (u.shotN = (u.shotN || 0) + 1) >= 3) {
          u.shotN = 0;
          const d = L(u.spec.skills[i].stun, u.skillLv[i]) * (t.kind === 'hero' ? 0.5 : 1);
          this.applyCC(u, t, { stun: d });
          if (u.human || t.human) this.dmgEvents.push({ x: t.x, y: t.y - 50, text: '連珠', team: t.team, src: u.id, tgt: t.id });
        }
      }
    }),
  ],
});
